import React, { useEffect } from 'react'
import { makeStyles } from '@material-ui/core'
import { useMediaQuery } from 'react-responsive'
import { Grid, Typography } from '@material-ui/core'
import { footerService } from '../model/footer-services'
import { useSelector } from 'react-redux'
import { useState } from 'react'
import { useTranslation } from "react-i18next";
import i18next from 'i18next'

const useStyles=makeStyles((theme)=>({
  hide:{
    fontSize:"6px",
    color:"transparent",
  },
  hide2:{
    fontSize:"6px",
    color:theme.palette.ePrimary.base,
  }
}))
function EFooter() {
  const {t:contents, ready: contentReady} = useTranslation("content-E_AUTH_FOOTER");
  const {t:labels} = useTranslation("label-E_NESCO_TERMS") ;
    const classes=useStyles()
    const isTabletOrMobile=useMediaQuery({query:"(max-width: 550px)"})
    const [footer,setFooter]=useState("")
    const languageCode = useSelector(
        (state) =>
          state?.parametersWidgets?.ParameterLookup?.TENANT_PRIMARY_LANGUAGE
      );
    useEffect(()=>{
      if(contentReady && i18next.language){
          setFooter(contentReady?contents("E_AUTH_FOOTER").answer:"");
  
      }
      
    },[i18next,contentReady])
  return (
    <div>
    <Typography 
        variant={isTabletOrMobile?"caption":"subtitle1"}>
        {contents("E_AUTH_FOOTER").answer} <span  className={isTabletOrMobile ?classes.hide2:classes.hide }>{labels("E_POWEREDBY")}</span>
        
          
    </Typography>
    </div>
        
    
  )
}

export default EFooter
